// extracted by mini-css-extract-plugin
export default {"header":"XBAjoKhvz7PcHMHX39Eu","user":"swrBDWOwe1s6lDoldxnb","userActive":"j0eBVrL1nh7O9yvoIuMK","tabsList":"O1spvJ6xOJmPjjeco1Xg","tab":"ykILbmA2OZDJ79leHlbp"};